import {
  UnidadAdministrativa,
  UnidadAdministrativaFiltro,
  UnidadAdministrativaPageResponse
} from '../../model/unidad-administrativa/unidad-administrativa';

/**
 * Puerto Abstracto: UnidadAdministrativaRepository
 * 
 * Define el contrato para gestión de unidades administrativas.
 * Migrado desde: FilterProgramarServiciosViewImpl.java
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpUnidadAdministrativaRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class UnidadAdministrativaRepository {

  /**
   * Busca unidades administrativas activas con filtros opcionales y
   * paginación por cursor (keyset pagination, ver skill acceso-datos-oracle §7).
   * Solo retorna unidades activas (FEBAJA IS NULL AND SNACTIVO = 'S').
   *
   * @param filtro Filtros de búsqueda (código, nombre)
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param direction NEXT | PREVIOUS | LAST
   * @returns Página de unidades administrativas
   */
  abstract buscarUnidadesAdministrativas(
    filtro: UnidadAdministrativaFiltro,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<UnidadAdministrativaPageResponse>;
}
